/* eslint-disable @typescript-eslint/no-explicit-any */

import { TAssetType } from "./enum";
import type { Abi, Account } from "viem";
import type { Chain } from "wagmi/chains";

export enum SmartContractEnum {
  IDENTITY = "identity",
  AFFILIATE_MANAGER = "affiliateManager",
  FREE_GAS_MANAGER = "freeGasManager",
  FIAT = "fiat",
  PANCAKE_ROUTER = "pancakeRouter",
  PANCAKE_FACTORY = "pancakeFactory",
  PROJECT_PROFILE = "projectProfile",
  SINGLE_ASSET_MANAGER = "singleAssetManager",
  SINGLE_ASSET_BASE = "singleAssetBase",
  COLLECTION_ASSET_MANAGER = "collectionAssetManager",
  COLLECTION_ASSET_BASE = "collectionAssetBase",
  COLLECTION_ASSET_EXCHANGE = "collectionAssetExchange",
  SINGLE_POOL_ROUTER = "singlePoolRouter",
  SINGLE_POOL_FACTORY = "singlePoolFactory",
  TOPUP_MANAGER = "topupManager",
  HYPER_POOL_ROUTER = "hyperPoolRouter",
  HYPER_ASSET_BASE = "hyperAssetBase",
  VAULT_MANAGER = "vaultManager",
  VERIFY_DOCUMENT_MANAGER = "verifyDocumentManager",
}

export type TSmartContract = SmartContractEnum;

export class SmartContract {
  createdAt?: string;
  updatedAt?: string;
  contractName: TSmartContract;
  address: string;
  abiFileContent: string;
  chainId: string;
  frontEndTitle: string;
  abiFileName: string;
  initCodeHash?: string;
  executorWallet?: string;
  executorPrivateKey?: string;

  constructor();
  constructor(obj: SmartContract);
  constructor(obj?) {
    this.createdAt = obj?.createdAt || "";
    this.updatedAt = obj?.updatedAt || "";
    this.abiFileName = obj?.abiFileName || "";
    this.contractName = obj?.contractName || null;
    this.address = obj?.address || "";
    this.abiFileContent = obj?.abiFileContent || "";
    this.chainId = obj?.chainId || "";
    this.frontEndTitle = obj?.frontEndTitle || "";
    this.initCodeHash = obj?.initCodeHash || "";
    this.executorWallet = obj?.executorWallet || "";
    this.executorPrivateKey = obj?.executorPrivateKey || "";
  }
}

export class WagmiConfig {
  address: `0x${string}`;
  abi: Abi;
  chain: Chain;
  account: `0x${string}` | Account;

  constructor(obj?: Partial<WagmiConfig>) {
    this.address =
      (obj?.address as `0x${string}`) ??
      "0x0000000000000000000000000000000000000000";
    this.abi = obj?.abi ?? [];
    this.chain = obj?.chain;
    this.account = obj?.account;
  }
}

export class TransactionDTO {
  timestamp: string;
  from: string;
  to: string;
  value: string;
  amount: string;
  method: string;
  fee: string;
  isError: string;
  addressTo: string;

  constructor();
  constructor(obj?: TransactionDTO);
  constructor(obj?) {
    this.timestamp = obj?.timestamp || "";
    this.from = obj?.from || "";
    this.to = obj?.to || "";
    this.value = obj?.value || "";
    this.amount = obj?.amount || "";
    this.method = obj?.method || "";
    this.fee = obj?.fee || "";
    this.isError = obj?.isError || "";
    this.addressTo = obj?.addressTo || "";
  }
}

export class AssetTransaction {
  timestamp: number;
  blockNumber: number;
  method: string;
  from: string;
  to: string;
  price: number;
  fee: number;
  nftId: number;
  amount: number;
  assetType: TAssetType;
  assetAddress: string;
  status: boolean;
  transactionHash: string;
  transactionType: string;

  constructor();
  constructor(obj?: AssetTransaction);
  constructor(obj?) {
    this.timestamp = obj?.timestamp || null;
    this.blockNumber = obj?.blockNumber || null;
    this.method = obj?.method || null;
    this.from = obj?.from ? obj?.from.toLowerCase() : null;
    this.to = obj?.to ? obj?.to.toLowerCase() : null;
    this.price = Number(obj?.price || 0);
    this.fee = Number(obj?.fee || 0);
    this.nftId = Number(obj?.nftId || 0);
    this.amount = Number(obj?.amount || 0);
    this.assetType = obj?.assetType || null;
    this.assetAddress = obj?.assetAddress
      ? obj?.assetAddress.toLowerCase()
      : null;
    this.status = obj?.status || false;
    this.transactionHash = obj?.transactionHash || null;
    this.transactionType = obj?.transactionType || null;
  }
}
